module.exports = __webpack_public_path__ + "img/r.882a002b.jpg";